<template>
  <!-- 着払い番号一括設定 -->
  <div id="HSTPaymentNumberBulkSetting">
    <div id="container">
      <div class="labelTitle lable">着払い番号一括設定</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div class="invoiceBulkSettingTable-area">
        <b-table
            :data="rebuildingTableData"
            id="invoiceBulkSettingTable"
            pagination-position="both"
            default-sort="reserveTime"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column label="#" width="50" centered>{{props.index +1}}</b-table-column>
              <b-table-column field="paymentNumber" label="着払い番号" width="200" sortable centered>
                <input :id="'paymentNumber' + props.index" type="text" v-model="props.row.paymentNumber" @keyup.enter="onKeyupEnter(props.index)" :disabled="!props.row.editFlag" maxlength="14"/>
              </b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="120" centered sortable>
                {{props.row.receiptNumber}}
              </b-table-column>
              <b-table-column field="reserveTime" label="機器予約コード" width="140" centered sortable>
                {{props.row.reserveTime}}
              </b-table-column>
              <b-table-column field="receiverName" label="配送先宛名" width="180" sortable >
                {{props.row.receiverName }}
              </b-table-column>
              <b-table-column field="receiverAddress" label="配送先住所" sortable >
                {{props.row.receiverAddress }}
              </b-table-column>
              <b-table-column field="instrumentKind" label="機種" width="150" sortable >
                {{props.row.instrumentKind | getNameFilter(modelList) }}
              </b-table-column>
              <b-table-column field="snoreSensor" label="いびきセンサー同梱の有無" width="120" sortable >
                {{props.row.snoreSensor | snoreSensorFilter(props.row.instrumentKind) }}
              </b-table-column>
              <b-table-column field="shippingAddress" label="配送先タイプ" width="110" sortable>
                {{props.row.shippingAddress }}
              </b-table-column>
            </template>
        </b-table>
    　</div>
      <div class="button-area">
        <b-button class="is-primary" @click="paymentNumberBulkSet">着払い番号登録</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {hstModelValue} from "@/components/mock/base/const.js";
export default {
  name: "HSTPaymentNumberBulkSetting",
  data() {
    var searchParams = this.$route.params["searchConditions"];
    var modelList = this.$route.params["modelList"];
    return {
      receivedTableData: [],
      rebuildingTableData: [],
      searchParams,
      modelList,
      bulkSetData:[]
    };
  },
  methods: {
    back: function () {
      this.$router.push({
        name: "HSTShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    onKeyupEnter: function(index){
      //フォーカスを移動
      let nextElement = document.getElementById("paymentNumber" + (index + 1));
      if(nextElement){
        // 次のアイテムが存在する場合、フォーカスを移動
        nextElement.focus();
      }else{
        // 次のアイテムが存在しない場合、フォーカスを外す
        let element = document.getElementById("paymentNumber" + (index));
        element.blur();
      }
    },
    paymentNumberBulkSet: function() {
      this.bulkSetData = []
      var notInputPaymentNumber = false
      var notEditData = false
      for(let item of this.rebuildingTableData){
        if(item.paymentNumber && item.editFlag){
          var req = {
            receiptNumber: item.receiptNumber,
            paymentNumber: item.paymentNumber,
            invoiceNumber: item.invoiceNumber
          }
          this.bulkSetData.push(req)
        }else if(!item.paymentNumber && item.editFlag){
          notInputPaymentNumber = true
        }else if(item.paymentNumber && !item.editFlag){
          notEditData = true
        }
      }
      if(this.bulkSetData.length == 0){
        if(notInputPaymentNumber){
          this.showErrorMessage("着払い番号が入力されていません。")
        }else if (notEditData){
          this.showErrorMessage("着払い番号登録対象が含まれていない為、<br>番号登録できません。")
        }
        return
      }
      var excuteApi = this.setHstNumberPOST;
      var successCallBack = this.setHstNumberPOSTSuccess;
      var errorCallBack = this.setHstNumberPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstNumberPOST: function(client) {
      return client.apis.internalHst.setHstNumberPOST({
        body: this.bulkSetData
      });
    },
    setHstNumberPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setHstNumberPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    rebuildTableData() {
      this.receivedTableData = this.$route.params["data"];
      this.receivedTableData.forEach(parent => {
        for(var i = 0; i < parent.receiptNumber.length; i++) {
          this.rebuildingTableData.push({
            receiptNumber: parent.receiptNumber[i],
            paymentNumber: parent.paymentNumbers[i],
            reserveTime: parent.reserveTime,
            invoiceNumber: parent.invoiceNumber,
            receiverName: parent.receiverName,
            receiverAddress: parent.receiverAddress,
            instrumentKind: parent.instrumentKind,
            snoreSensor: parent.snoreSensor,
            shippingAddress: parent.shippingAddress,
            editFlag: parent.editFlag,
          });
        }
      });
    }
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    snoreSensorFilter: function(value, instrumentKind){
      if (instrumentKind == hstModelValue.WP300) {
        if (value == "1") {
          return "無"
        } else if (value == "2") {
          return "有"
        }
      } else {
        return "-"
      }
    },
  },
  created() {
    this.rebuildTableData();
  }
};
</script>
<style lang="scss" scoped>
.invoiceBulkSettingTable-area {
  margin-top: 20px;
  width:1350px;
  max-height: 650px;
  overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/philips/hst/shipping/HSTPaymentNumberBulkSetting.vue